import { Typography } from 'antd'
import { apiDelete } from 'api'
import CustomButton from 'components/atoms/CustomButton'
import ModalAdmin from 'components/molecules/admin/ModalAdmin'
import i18next from 'i18next'
import React from 'react'
import { useSelector } from 'react-redux'
import { showErrorMessage } from 'utils/showMessage'
import { useTranslation } from 'react-i18next'
const ReactivateSubscriptionCompanyModal = ({ show, onClose, onReactivateSubscription }) => {
  const { t } = useTranslation();
 

  return (
    <ModalAdmin title={t('Plans.Reactivate subscription')} onClose={onClose} show={show}>
      <div className="flex flex-col gap-2">
        <Typography.Paragraph className="!text-[#FFFFFFCC] !font-manrope !text-lg">
          {t('Plans.Reactivate subscription text')}
        </Typography.Paragraph>

        <div className="flex gap-2 justify-end items-center">
          <CustomButton buttonColor="secondary" onClick={onClose}>
           {t('Cancel') }
          </CustomButton>
          <CustomButton
            buttonColor="danger"
            onClick={onReactivateSubscription}>
            {t('Plans.Reactivate') }
          </CustomButton>
        </div>
      </div>
    </ModalAdmin>
  )
}

export default ReactivateSubscriptionCompanyModal
